// extracted by mini-css-extract-plugin
module.exports = {"verdict":"PaidNotPaid_verdict__2btrk","paid":"PaidNotPaid_paid__3Dx2t","not_paid":"PaidNotPaid_not_paid__3oObO"};